import { render, staticRenderFns } from "./regresos.vue?vue&type=template&id=35f574ba&scoped=true"
import script from "./regresos.vue?vue&type=script&lang=js"
export * from "./regresos.vue?vue&type=script&lang=js"
import style0 from "./regresos.vue?vue&type=style&index=0&id=35f574ba&prod&scoped=true&lang=css"
import style1 from "./regresos.vue?vue&type=style&index=1&id=35f574ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f574ba",
  null
  
)

export default component.exports